import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import TranslatesContent from "../../../../DataStore/Languages/translatesContent";

const RegisterButtonResend = ({ reSendOtp, otpResendLoad }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const verifyRecaptha = async () => {
    if (!executeRecaptcha) {
      return false;
    }

    const token = await executeRecaptcha("yourAction");
    return token;
  };

  const checkRecaptha = (e) => {
    e.preventDefault();
    verifyRecaptha().then((token) => {
      if (token) {
        reSendOtp(e, token);
      } else {
      }
    });
  };

  return (
    <button className={`joinTopbutton ${otpResendLoad ? 'disabled' : ''}`} disabled={otpResendLoad} onClick={(e) => checkRecaptha(e)}>
    {otpResendLoad ? (
        "Please wait"
      ) : (
        <TranslatesContent contentKey="resend" />
      )}
    </button>
  );
};

export default RegisterButtonResend;
